// extracted by mini-css-extract-plugin
module.exports = {"container":"History_container__3X7KN","emptyLabel":"History_emptyLabel__13Yfb"};